import { defineMessages } from 'react-intl';

export default defineMessages({
  heading: {
    id: 'shared.couponCard.heading',
    defaultMessage: 'Coupon available',
    description: 'Heading for coupon card to display available coupons',
  },
  applyCta: {
    id: 'shared.couponCard.applyCta',
    defaultMessage: 'Apply',
    description: 'CTA text to apply coupon',
  },
  birthdayHeading: {
    id: 'shared.couponCard.birthdayHeading',
    defaultMessage: 'Birthday Reward available',
    description: 'Heading for informational birthday coupon',
  },
  birthdayBody: {
    id: 'shared.couponCard.birthdayBody',
    defaultMessage:
      'Enjoy a free drink or food item on us. Tell the barista you’re redeeming this before you pay. {couponDate}',
    description: 'Birthday coupon card description message',
  },
  mopOnlyHeading: {
    id: 'shared.couponCard.mopOnlyHeading',
    defaultMessage: 'Coupon available (order ahead only)',
    description:
      'Heading for coupon that can only be redeemed with Mobile Order & Pay',
  },
  multiDayCouponExpiration: {
    id: 'shared.couponValidityDate.multiDayCouponExpiration',
    defaultMessage: 'Valid {startDate} - {expireDate}',
    description: 'Text to indication single coupons expiration day',
  },
  singleDayCouponExpiration: {
    id: 'shared.couponValidityDate.singleDayCouponExpiration',
    defaultMessage: 'Valid on {expireDate}',
    description: 'Text to indication single coupons expiration day',
  },
});
